import { render, staticRenderFns } from "./TaskQuantidadesTotal.vue?vue&type=template&id=10c67ba0"
import script from "./TaskQuantidadesTotal.vue?vue&type=script&lang=js"
export * from "./TaskQuantidadesTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports